module.exports = __webpack_public_path__ + "static/media/imagenservicios1.3569976b.png";